import React, { useState } from 'react';

import { Checkbox } from '@mui/material';

import { ConfirmModal } from 'components/modal';
import { useFormMutation } from 'mutations/useFormMutation';
import { DreStatus } from 'pages/financeiro/dre/types';

type DreLiberarCheckbox = {
    dreStatusEnum: DreStatus['dreStatusEnum'];
    id: number;
    refresh: () => void;
    isLoading: boolean;
    error: string;
};

export function DreLiberarCheckbox({ dreStatusEnum, id, refresh, isLoading, error }: DreLiberarCheckbox) {
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const [checked, setChecked] = useState(false);
    const { mutate } = useFormMutation();
    const isFinalizado = dreStatusEnum === 'FINALIZADO';
    const isBloqueado = dreStatusEnum === 'BLOQUEADO';
    const disabled = Boolean((!isFinalizado && !isBloqueado) || isLoading || error);

    const handleChangeLiberarDre = (): void => {
        setChecked(true);

        setOpenConfirmModal(true);
    };

    const confirmChangeLiberarDre = (): void => {
        mutate(
            {
                url: `/dre/dremercadologica/libera?idDreMercadologica=${id}`,
                method: 'PUT',
            },
            {
                onSuccess: () => {
                    refresh();

                    setChecked(false);
                },
                onError: () => setChecked(false),
            },
        );
    };

    return (
        <>
            <Checkbox checked={checked} onChange={handleChangeLiberarDre} disabled={disabled} />

            <ConfirmModal
                open={openConfirmModal}
                setOpen={setOpenConfirmModal}
                confirm={confirmChangeLiberarDre}
                cancel={() => setChecked(false)}
                text="Tem certeza que deseja liberar para preenchimento a estimativa de resultado selecionada?"
            />
        </>
    );
}
